import { useCallback, useEffect, useState } from "react";
import {
    anularMovimiento,
    crearMovimiento,
    listarMovimientos,
    actualizarMovimiento,
} from "../api/movimientoApi";
import { getUser } from "../utils/storage";

function normalizarMovimiento(row) {
    return {
        ...row,
        idMovimiento: row.idMovimiento ?? row.id_movimiento ?? null,
        tipoMovimiento: row.tipoMovimiento ?? row.tipo_movimiento ?? "",
        fechaMovimiento: row.fechaMovimiento ?? row.fecha_movimiento ?? "",
        fechaPago: row.fechaPago ?? row.fecha_pago ?? "",
        idMoneda: row.idMoneda ?? row.id_moneda ?? "",
        tipoCambio: row.tipoCambio ?? row.tipo_cambio ?? "",
        idCategoria: row.idCategoria ?? row.id_categoria ?? "",
        idSubcategoria: row.idSubcategoria ?? row.id_subcategoria ?? "",
        idCuenta: row.idCuenta ?? row.id_cuenta ?? "",
        idMetodoPago: row.idMetodoPago ?? row.id_metodo_pago ?? "",
        idTipoComprobante: row.idTipoComprobante ?? row.id_tipo_comprobante ?? "",
        numeroComprobante: row.numeroComprobante ?? row.numero_comprobante ?? "",
        esRecurrente: row.esRecurrente ?? row.es_recurrente ?? false,
        esFijo: row.esFijo ?? row.es_fijo ?? false,
        esDeducible: row.esDeducible ?? row.es_deducible ?? false,
        usuarioCrea: row.usuarioCrea ?? row.usuario_crea ?? "",
        fechaCrea: row.fechaCrea ?? row.fecha_crea ?? "",
        usuarioModifica: row.usuarioModifica ?? row.usuario_modifica ?? "",
        fechaModifica: row.fechaModifica ?? row.fecha_modifica ?? "",
        usuarioAnula: row.usuarioAnula ?? row.usuario_anula ?? "",
        fechaAnula: row.fechaAnula ?? row.fecha_anula ?? "",
        categoriaNombre: row.categoriaNombre ?? row.categoria_nombre ?? "",
        subcategoriaNombre: row.subcategoriaNombre ?? row.subcategoria_nombre ?? "",
        cuentaNombre: row.cuentaNombre ?? row.cuenta_nombre ?? "",
    };
}

export default function useMovimientos() {
    const [movimientos, setMovimientos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtros, setFiltros] = useState({
        tipo: "",
        fechaInicio: "",
        fechaFin: "",
        idCuenta: "",
        idCategoria: "",
    });

    const recargar = useCallback(async () => {
        setLoading(true);
        try {
            const data = await listarMovimientos(filtros);
            setMovimientos(Array.isArray(data) ? data.map(normalizarMovimiento) : []);
        } catch (e) {
            console.error("Error al listar movimientos:", e);
            setMovimientos([]);
        } finally {
            setLoading(false);
        }
    }, [filtros]);

    useEffect(() => {
        recargar();
    }, [recargar]);

    const guardarMovimiento = async (payload, idMovimiento) => {
        if (idMovimiento) {
            await actualizarMovimiento(idMovimiento, payload);
        } else {
            await crearMovimiento(payload);
        }
        await recargar();
    };

    const anular = async (idMovimiento) => {
        const user = getUser();
        await anularMovimiento(idMovimiento, user?.idUsuario || 0);
        await recargar();
    };

    return {
        movimientos,
        loading,
        filtros,
        setFiltros,
        guardarMovimiento,
        anular,
        recargar,
    };
}